import { FC } from 'react';
import { Navigate, Route } from 'react-router-dom';
import AnimatedRouter from 'components/AnimatedRouter';
import Card from 'components/Card';
import Details from './Details';

const Syep: FC = () => {
    return (
        <Card page>
            <AnimatedRouter component={null} timeout={300}>
                <Route path="details" element={<Details />} />
                {/* 其他子路由可以在这里添加 */}
                <Route path="*" element={<Navigate to="../details" replace />} />
            </AnimatedRouter>
        </Card>
    );
};

export default Syep;
